import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  span: {
    border: 0,
    margin: 0,
    padding: 0,
    fontSize: theme.tokens.typography.variant.body2.fontSize,
    fontWeight: theme.tokens.typography.variant.body2.fontWeight,
    letterSpacing: theme.tokens.typography.variant.body2.letterSpacing,
    lineHeight: theme.tokens.typography.variant.body2.lineHeight,
    whiteSpace: 'pre',
  },
  hidden: {
    visibility: 'hidden',
    position: 'absolute',
  },
  input: {
    border: 0,
    margin: 0,
    padding: 0,
    fontSize: theme.tokens.typography.variant.body2.fontSize,
    fontWeight: theme.tokens.typography.variant.body2.fontWeight,
    letterSpacing: theme.tokens.typography.variant.body2.letterSpacing,
    lineHeight: theme.tokens.typography.variant.body2.lineHeight,
    color: theme.tokens.colors.original.brand.primary,
    caretColor: theme.tokens.colors.original.brand.primary,
    minWidth: 30,
    height: 'auto',

    '&&&::before': {
      border: 0,
    },
    '&&&::after': {
      border: 0,
    },
  },
}));
